export const SELECT_STEP = 'choicepanel/select-step'
export const ADD_TO_CART = 'choicepanel/add-to-cart'
export const GET_A_QUOTE = 'choicepanel/get-a-quote'
export const SET_SHOW_INTERACTION_REQUIRED_WARNINGS = 'choicepanel/set-show-interaction-required-warnings'
export const SET_IS_SUBMITTING = 'choicepanel/is-submitting'
export const SHOW_SUBMIT_ERROR = 'choicepanel/submit-error'
export const SET_IS_SUBMIT_VALID = 'choicepanel/set-is-submit-valid'
export const SET_MOBILE_DESCRIPTION = 'choicepanel/set-mobile-description'
export const ADD_VISITED_QUESTIONS = 'choicepanel/add-visited-questions'
